<template>
  <div ref="search-results" id="search-results" class="tx-products module-search-results">
    <div class="search-results__results" v-if="!resultsIsEmpty()">
      <SearchResult
        v-for="(result) in results"
        :result="result"
        :key="result.uid"
      />
      <div class="tx-products module-search-result module-search-result--placeholder"></div>
      <div class="tx-products module-search-result module-search-result--placeholder"></div>
    </div>
    <div class="search-results__load-page" v-if="!resultsIsEmpty() && !morePages()">
      <div class="last-page__button" :class="{'-inactive': currentPage === 1}" @click="loadPageBefore"></div>
      <div class="page-buttons__wrapper">
        <div class="page__button" v-for="(number) in numberOfPages" :key="'page-number-' + number" :class="{'-current': number === currentPage}" @click="scrollAndLoadPage(number)">
          <span>{{ number }}</span>
        </div>
      </div>
      <div class="next-page__button" :class="{'-inactive': currentPage === numberOfPages}" @click="loadNextPage"></div>
    </div>
    <div class="search-results__error" v-if="loaded && resultsIsEmpty ()">
      <span>{{ $t('productList.filter.error') }}</span>
    </div>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'
import SearchResult from '@/components/SearchResult'

export default {
  name: 'SearchResults',
  components: {
    SearchResult
  },
  computed: {
    ...mapState({
      initialized: state => state.initialized,
      results: state => state.product.products,
      loaded: state => state.product.loaded,
      currentPage: state => state.product.currentPage,
      itemsPerPage: state => state.product.itemsPerPage,
      numberOfPages: state => state.product.numberOfPages,
      numberOfTotalItems: state => state.product.numberOfTotalItems
    })
  },
  methods: {
    ...mapActions([
      'loadNextPage',
      'loadPageBefore',
      'loadPage'
    ]),
    scrollAndLoadPage (number) {
      this.loadPage(number)

      setTimeout(() => {
        const element = this.$refs['search-results']
        const yOffset = -200
        const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
        window.scrollTo({ top: y, behavior: 'smooth' })
      }, 100)
    },
    resultsIsEmpty () {
      return !(this.results.length > 0)
    },
    morePages () {
      return !(this.numberOfPages > 1)
    }
  }
}
</script>
